/**
 * One wallet-held Paid ECF pledge in the "ECF investment" hold bucket.
 *
 * Mirrors the per-pledge item returned by
 *   GET Api/v1/MySec/{role}/wallets/heldEcfInvestments
 * where `{role}` resolves to individualInvestor / companyRep via the HTTP interceptor.
 *
 * The list already reconciles to `ecfInvestmentHoldAmount` server-side (same
 * transaction selection + campaign-status gate as the subtotal), so render — do
 * not re-sum-and-diverge. `campaignId` is currently unused by the UI, but can
 * support future deep-links from the drill-down list.
 */
export interface HeldEcfInvestmentModel {
  campaignId: number;
  campaignName: string;
  paidAt: string;
  amount: number;
}

export interface HeldEcfInvestmentsResponseModel {
  investments: HeldEcfInvestmentModel[];
  ecfInvestmentHoldAmount: number;
}

export class HeldEcfInvestment {
  campaignId: number;
  campaignName: string;
  paidAt: string;
  amount: number;

  constructor(model: HeldEcfInvestmentModel) {
    this.campaignId = model.campaignId;
    this.campaignName = model.campaignName;
    this.paidAt = model.paidAt;
    this.amount = model.amount;
  }
}

export class HeldEcfInvestments {
  investments: HeldEcfInvestment[];
  ecfInvestmentHoldAmount: number;

  constructor(model: HeldEcfInvestmentsResponseModel) {
    this.investments = model?.investments
      ? model.investments.map((i) => new HeldEcfInvestment(i))
      : [];
    this.ecfInvestmentHoldAmount = model?.ecfInvestmentHoldAmount ?? 0;
  }
}
